import React, { useEffect, useState } from "react";
import MediaPicker from "../mediaPicker";
import { callHomeAdvertise } from "../../callApi/home";
import { fileUpload } from "../../../fileUpload";
import config from "../../Config.json";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import IsActive from "../AdminisActive";
import SaveButton from "../AdminButtons";

const Section1 = () => {
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;

  const [option, setOption] = useState(false);

  const [data, setData] = useState({
    AdminId: AdminId,
    featureImage: {
      image: "",
      file: "",
      status: "none",
    },
  });

  const _data = data;

  const updateData = () => {
    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  const handleImageChange = (file, image) => {
    _data.featureImage.image = image;
    _data.featureImage.file = file;
    _data.featureImage.status = "updated";

    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  const dispatch = useDispatch();

  const handleSave = async () => {
    if (data.featureImage.image !== "") {
      if (data.featureImage.status === "updated") {
        fileUpload([data.featureImage]).then((uploadImageRes) => {
          if (uploadImageRes?.length > 0) {
            const newUploadedImages = uploadImageRes[0].key;
            saveData(newUploadedImages);
          }
        });
      } else {
        saveData(data.featureImage.image);
      }
    } else {
      toast.error("Please fill all values");
    }
  };

  const saveData = (imageUrl) => {
    const params = {
      showinwebsite: option ? 1 : 0,
      images: imageUrl,
      AdminId: AdminId,
    };
    callHomeAdvertise(params).then((res) => {
      if (res) {
        toast.success("Data saved successfully");
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  useEffect(() => {
    const AdvertiseData = JSON.parse(
      sessionStorage.getItem("homeApi")
    ).Advertise;
    _data.featureImage = { image: config.awsMediaPath + AdvertiseData.media };
    setOption(AdvertiseData ? AdvertiseData.showinwebsite === 1 : false);
    updateData();
  }, []);

  return (
    <div className="sec">
      <div className="sec">
        <h1 className="sec-1-header">Section 1</h1>
        <section>
          <MediaPicker
            text="Feature image"
            type="image"
            onChange={handleImageChange}
            source={data.featureImage.image}
          />
        </section>

        <div className="input-field">
          <label>
            <span>
              <IsActive checked={option} onChange={() => setOption(!option)} />
            </span>
          </label>
        </div>
        <SaveButton onClick={handleSave} />
      </div>
    </div>
  );
};

export default Section1;
